import { logComponentEvent } from '@Utilities/services/logging/componentEvent';

export const useGiftSuccess = () => {
  const onSuccessDoneClick = () => {
    logComponentEvent('GiftingSuccess', 'CtaClicked');
    window.location.href = 'https://embark.ca';
  };

  return {
    onSuccessDoneClick
  };
};
